import React from "react"
import styled from "styled-components"
import { useTranslation } from "react-i18next"
import { TxlLink } from "./TxlLink"
import { getRoute } from "../helpers/routing"

const FooterLink = (props) => <TxlLink $underline={true} {...props} />

const LegalFooter = ({ className }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation("generic")

  return (
    <div className={className}>
      <ul>
        <li>
          <FooterLink to={getRoute("/legal/terms", language)}>
            {t("##.Menu.TermsAndConditions")}
          </FooterLink>
        </li>
        <li>
          <FooterLink to={getRoute("/legal/privacy", language)}>
            {t("##.Menu.PrivacyPolicy")}
          </FooterLink>
        </li>
        <li>
          <FooterLink to={getRoute("/contact", language)}>
            {t("##.Menu.Contact")}
          </FooterLink>
        </li>
      </ul>
    </div>
  )
}

const StyledLegalFooter = styled(LegalFooter)`
  background-color: ${props => props.theme.color.semiTranslucid};
  margin-top: 60px;
  position: relative;
  padding: 20px 0 20px 0;

  ul {
    text-align: center;
  }

  li {
    list-style: none;
    display: inline;
    padding: 0 15px 0 15px;
  }
`

export default StyledLegalFooter
